import React, { useState } from 'react';
import { toast } from 'react-toastify';
import useMain from '../../../../hooks/useMain';
import http from '../../../../services/httpService';
import getCard from '../../../../utils/getCard';
import { numberWithCommas, titleCase } from '../../../../utils/helpers';
import { FlippingDebit } from '../../ingredients/cards';
import PurchasePackageForm from './purchasePackageForm';

const PurchasePackage = ({ history }) => {
	const { userData, initData, onUserDataChanged, theme } = useMain();
	const { currentCard } = userData;
	const [isSubmited, setIsSubmited] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [errors, setErrors] = useState({});
	const [cardType, setCardType] = useState(
		userData.cardPurchaseOptions.find((o) => o.checked === true).id
	);

	const getRealPackage = (amount) => {
		const { percentage } = getCard(amount, cardType, initData);
		const newCard = getCard(amount + currentCard.totalAmount, cardType, initData);
		return {
			...newCard,
			percentage,
		};
	};

	const [card, setCard] = useState(
		getRealPackage(userData.cardPurchaseOptions.find((o) => o.checked).min)
	);

	const handleAmountChange = ({ currentTarget: amount }) =>
		setCard(getRealPackage(Number(amount.value) * 1e6));

	const handleCardTypeChange = ({ currentTarget }) => {
		setCard(
			getCard(
				userData.cardPurchaseOptions.find((o) => o.id === currentTarget.id).min,
				currentTarget.id,
				initData
			)
		);
		setCardType(currentTarget.id);
	};

	const handlePurchase = async (formData) => {
		if (!formData.isOverallBalanceEnough)
			return setErrors({
				amount: 'Not enough balance',
			});
		try {
			const { amount, purchaseType, securityPassword, cardType } = formData;
			setIsLoading(true);
			const { data } = await http.purchase({
				amount: Number(amount),
				purchaseType,
				securityPassword,
				cardType,
			});
			onUserDataChanged(data.data);
			toast.success(data.message);
			setIsSubmited(true);
			setIsLoading(false);
			history.replace('/dashboard/maxCap');
		} catch (ex) {
			setIsLoading(false);
			console.log(ex);
			if (ex && ex.response && ex.response.data) return toast.error(ex.response.data);
			if (ex && ex.message) return toast.error(ex.message);
		}
	};

	return (
		<div className='card myCards'>
			<div className='card-body'>
				<div className='row align-items-center my-1'>
					<div className='col-lg-4 text-center order-1 order-lg-0'>
						<div className='fs-5'>{titleCase(`${card.name} ${cardType} card`)}</div>
						<div className='fs-6 mb-3'>
							($
							{numberWithCommas(initData.cards[card.name].min / 1e6)} - $
							{numberWithCommas(initData.cards[card.name].max / 1e6)})
						</div>
						<FlippingDebit
							card={card.name}
							text={userData.bemchain.uid}
						/>
						{cardType === 'planner' && (
							<div className='text-start fs-7 m-3'>
								<b>Note:</b> For Planner Packages, <b>MaxCap</b> is calculated by
								the sum of your previous active packages and the amount of your new
								package.
							</div>
						)}

						<div className='mx-sm-4'>
							<div className='d-flex justify-content-between  mt-4 fs-6'>
								<span>Internal Exchange Limit:</span>
								<span>{numberWithCommas(card.sellLimit / 1e6)}$</span>
							</div>
							<hr className='my-2' />
							<div className='d-flex justify-content-between fs-6'>
								<span>Withdraw Limit:</span>
								<span>{numberWithCommas(card.withdrawLimit / 1e6)}$</span>
							</div>
							<hr className='my-2' />
							<div className='d-flex justify-content-between fs-6'>
								<span>Monthly ROI Percentage:</span>
								<span>{card.percentage}%</span>
							</div>
							{cardType === 'planner' && (
								<>
									<hr className='my-2' />
									<div className='d-flex justify-content-between fs-6'>
										<span>Daily Binary Limit:</span>
										<span>
											{numberWithCommas(card.dailyBinaryLimit / 1e6)}$
										</span>
									</div>
									<hr className='my-2' />
									<div className='d-flex justify-content-between fs-6'>
										<span>MLM:</span>
										<span>{card.mlm} level(s)</span>
									</div>
								</>
							)}
							<hr className='my-2' />
							<div className='d-flex justify-content-between fs-6'>
								<span>Max Cap:</span>
								<span>{`${card.maxCap}%`}</span>
							</div>
						</div>
					</div>
					<div className='col-lg-6 offset-lg-1 mb-5 mb-lg-0'>
						<PurchasePackageForm
							theme={theme}
							cards={initData.cards}
							cardTypeOptions={userData.cardPurchaseOptions}
							onFormChange={() => setIsSubmited(false)}
							isSubmited={isSubmited}
							errors={errors}
							min={
								userData.cardPurchaseOptions.find((o) => o.id === cardType).min /
								1e6
							}
							max={
								userData.cardPurchaseOptions.find((o) => o.id === cardType).max /
								1e6
							}
							step={initData.stepPurchase}
							isLoading={isLoading}
							hasSP={userData.hasSP}
							options={initData.purchaseOptions}
							activationBalance={userData.wallets.activation.available / 1e6}
							discountBalance={userData.wallets.discount.available / 1e6}
							onAmountChange={handleAmountChange}
							onCardTypeChange={handleCardTypeChange}
							onSubmit={handlePurchase}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PurchasePackage;
